import { validations } from "validations/FormValidations";

  export const designFields = (periodOptions:{ label: string; value: string; }[]) => [
    {
      name: "designtitle",
      label: "Design Title",
      placeholder: "Enter Design Title",
      required: true,
      type: "text" as const,
      rules: validations.design.designtitle,
      maxLength: 50,
    },
    {
      name: "sequencetype",
      label: "Sequence Type (e.g. TR, RT)",
      placeholder: "Enter Sequence Type",
      required: true,
      type: "text" as const,
      rules: validations.design.sequencetype,
      maxLength: 50,
    },
    {
      name: "numberofsequences",
      label: "Number of Sequences",
      placeholder: "Auto-calculated",
      type: "number" as const,
      disabled: true,
    },
    {
      name: "numberoftreatments",
      label: "Number of Treatments",
      placeholder: "Auto-calculated",
      type: "number" as const,
      disabled: true,
    },
    {
      name: "period",
      label: "Period",
      placeholder: "Enter Period",
      required: true,
      type: "select" as const,
      options: periodOptions,
      rules: validations.design.period,
    },
    {
      name: "blocksize",
      label: "Block Size",
      placeholder: "Enter Block Size",
      description: "Default value is 4. This field is auto-filled and cannot be changed.",
      required: true,
      type: "number" as const,
      disabled: true,
      rules: validations.design.blocksize,
    },
  ];


    export const designColumns =  [
    {
      key: "designtitle",
      label: "Design Title",
    },
    {
      key: "sequencetype",
      label: "Sequence Type",
    },
    {
      key: "period",
      label: "Period",
    },
    {
      key: "numberofsequences",
      label: "Number of Sequences",
    },
    {
      key: "numberoftreatments",
      label: "Number of Treatments",
    },
    {
      key: "blocksize",
      label: "Block Size",
      render: (_: any, row: any) => (row?.numberofsequences ? row.numberofsequences * 2 : "-"),
    },
  ];